import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type OnboardStepIndicatorProps = {
  currentStep: number;
  totalSteps: number;
};

export const OnboardStepIndicator: FC<OnboardStepIndicatorProps> = ({ currentStep, totalSteps }) => {
  const { t } = useTranslation();
  if (totalSteps < 2) return null;

  return (
    <div
      className="flex items-center justify-center gap-1.5"
      role="img"
      aria-label={t('community.onboard.step_label', { current: currentStep + 1, total: totalSteps })}
    >
      {Array.from({ length: totalSteps }, (_, step) => (
        <span
          key={`onboard-step-${step + 1}`}
          className={step === currentStep ? 'h-[7px] w-5 rounded-full bg-black' : 'size-1.5 rounded-full bg-black/15'}
        />
      ))}
    </div>
  );
};
